/* @flow */

import usePlugin from 'plugin/base/hook/usePlugin';
import { liveChatPlugin } from 'plugin/live-chat/setting/liveChatSettings';

export default function useLiveChat(): boolean {
  return usePlugin(liveChatPlugin);
}
